<svelte:options
	customElement={{
		tag: "inquiry-button",
		shadow: "none",
	}}
/>

<script lang="ts">
	import tippy from "svelte-tippy";
	import { OpenContactModalEvent } from "./contact-modal.svelte";

	import { initFluentContext, Localized, localize } from "@/localization";
	import SvgIcon from "@/components/svg-icon.svelte";

	let { size }: { size: "small" | "large" } = $props();

	function open() {
		document.dispatchEvent(new CustomEvent(OpenContactModalEvent));
	}

	initFluentContext();
</script>

{#if size === "large"}
	<button class="button is-info header-action" use:tippy={{ content: localize("inquiry-button.tooltip") }} onclick={open}>
		<SvgIcon customClass="icon--inquiry" size="is-large" icon="single-neutral-actions-question" />
		<span class="button__label"><Localized id="inquiry-button" /></span>
	</button>
{:else if size === "small"}
	<button class="button is-info header-action" use:tippy={{ content: localize("inquiry-button.tooltip") }} onclick={open}>
		<SvgIcon customClass="icon--inquiry" size="is-medium" icon="single-neutral-actions-question" />
		<span class="button__label"><Localized id="inquiry-button.label-short" /></span>
	</button>
{/if}
